import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Clock, AlertCircle } from 'lucide-react';
import clsx from 'clsx';
import styles from './StatusIcon.module.css';

export type StatusType = 'success' | 'error' | 'warning' | 'pending' | 'approved' | 'rejected' | 'info';

export interface StatusIconProps {
  status: StatusType;
  size?: number;
  className?: string;
}

const StatusIcon: React.FC<StatusIconProps> = ({ status, size = 16, className }) => {
  const getIcon = () => {
    switch (status) {
      case 'success':
      case 'approved':
        return <CheckCircle size={size} />;
      case 'error':
      case 'rejected':
        return <XCircle size={size} />;
      case 'warning':
        return <AlertTriangle size={size} />;
      case 'pending':
        return <Clock size={size} />;
      case 'info':
        return <AlertCircle size={size} />;
      default:
        return <AlertCircle size={size} />;
    }
  };

  const getStatusClass = () => {
    switch (status) {
      case 'success':
      case 'approved':
        return styles.success;
      case 'error':
      case 'rejected':
        return styles.error;
      case 'warning':
      case 'pending':
        return styles.warning;
      case 'info':
        return styles.info;
      default:
        return '';
    }
  };

  return <span className={clsx(getStatusClass(), className)}>{getIcon()}</span>;
};

export default StatusIcon;
